module.exports = __webpack_public_path__ + "img/frontlineDynamics.981a74bb.png";